import logger from '../common/logger';

const module = 'RedshiftTracker';
const RedshiftTracker = {
  trackEvent: (event) => {
    try {
      if (event.eventName === 'Order Conversion' || event.eventName === 'Page View') {
        return;
      }
      const url = 'https://bsgfni3xkk.execute-api.us-west-2.amazonaws.com/production/e';
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      xhr.onload = function () {

      }
      const json = JSON.stringify(event);
      xhr.send(json);
      return event;
    } catch (e) {
      logger.error('track failed', e, {module});
    }
  }
};
export default RedshiftTracker;